// src/routes/nationalitiesRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Nationalities from '../pages/nationalities/Nationalities';
import CreateNationalities from '../pages/nationalities/CreateNationalities';
import EditNationalities from '../pages/nationalities/EditNationalities';
import ProtectedRoute from '../components/global/ProtectedRoute';

const nationalitiesRoutes = (
    <>
        {/* Nationalities List */}
        <Route
            path="/nationalities"
            element={
                <ProtectedRoute requiredPermission="nationalities_list">
                    <Nationalities />
                </ProtectedRoute>
            }
        />

        {/* Nationalities Archive */}
        <Route
            path="/nationalities/archive"
            element={
                <ProtectedRoute requiredPermission="nationalities_archive_list">
                    <Nationalities />
                </ProtectedRoute>
            }
        />

        {/* Create Nationality */}
        <Route
            path="/nationalities/create"
            element={
                <ProtectedRoute requiredPermission="nationalities_create">
                    <CreateNationalities />
                </ProtectedRoute>
            }
        />

        {/* Edit Nationality */}
        <Route
            path="/nationalities/:id/edit"
            element={
                <ProtectedRoute requiredPermission="nationalities_edit">
                    <EditNationalities />
                </ProtectedRoute>
            }
        />
    </>
);

export default nationalitiesRoutes;